import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import siteConfig from '../config/contentConfig';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition - offset,
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      data-testid="nav-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'glass shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div
            data-testid="nav-logo"
            className="flex items-center space-x-2 cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <img
              src={siteConfig.images.floatingBanana}
              alt="$NANA Logo"
              className="h-10 w-10 animate-float"
            />
            <span className="text-2xl font-black text-[#32B44A]">
              {siteConfig.token.symbol}
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {siteConfig.navigation.map((item) => (
              <button
                key={item.id}
                data-testid={`nav-link-${item.id}`}
                onClick={() => scrollToSection(item.id)}
                className="text-slate-300 hover:text-[#FFD600] transition-colors duration-200 font-semibold"
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            <Button
              data-testid="connect-wallet-button"
              variant="outline"
              className="border-[#FFD600] text-[#FFD600] hover:bg-[#FFD600] hover:text-black btn-press"
            >
              Connect Wallet
            </Button>
            <Button
              data-testid="buy-nana-button"
              onClick={() => window.open(siteConfig.links.buyNana, '_blank')}
              className="bg-[#32B44A] hover:bg-[#28A745] text-white font-bold btn-press"
            >
              Buy $NANA
            </Button>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden text-white p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden glass border-t border-yellow-500/20">
          <nav className="flex flex-col space-y-4 p-6">
            {siteConfig.navigation.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-slate-300 hover:text-[#FFD600] transition-colors duration-200 font-semibold text-left"
              >
                {item.label}
              </button>
            ))}
            <div className="flex flex-col space-y-3 pt-4 border-t border-yellow-500/20">
              <Button
                variant="outline"
                className="border-[#FFD600] text-[#FFD600] hover:bg-[#FFD600] hover:text-black w-full"
              >
                Connect Wallet
              </Button>
              <Button
                onClick={() => window.open(siteConfig.links.buyNana, '_blank')}
                className="bg-[#32B44A] hover:bg-[#28A745] text-white font-bold w-full"
              >
                Buy $NANA
              </Button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
